// Keeps the focused field visible above the on-screen keyboard (tablets/phones, portrait and landscape).
// Sets --kb (keyboard height in px) on <html> so dialogs can shrink/shift, and scrolls the focused field into view.
export function installKeyboardGuard() {
  const vv = window.visualViewport;
  if (!vv) return;
  const root = document.documentElement;
  let focused = null;
  const update = () => {
    const kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    root.style.setProperty("--kb", `${kb > 80 ? kb : 0}px`);
    if (kb > 80 && focused && document.contains(focused)) {
      const r = focused.getBoundingClientRect();
      const visibleBottom = vv.height + vv.offsetTop - 12;
      if (r.bottom > visibleBottom || r.top < vv.offsetTop) focused.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  };
  vv.addEventListener("resize", update);
  vv.addEventListener("scroll", update);
  document.addEventListener("focusin", (e) => {
    const el = e.target;
    if (!(el instanceof HTMLElement) || !el.matches("input, textarea, select, [contenteditable]")) return;
    focused = el;
    setTimeout(update, 350);
    setTimeout(update, 700);
  });
  document.addEventListener("focusout", () => { focused = null; });
}
